import { render } from "./AddToOrder.vue?vue&type=template&id=5335a9a1&scoped=true&ts=true"
import script from "./AddToOrder.vue?vue&type=script&lang=ts"
export * from "./AddToOrder.vue?vue&type=script&lang=ts"

import "./AddToOrder.vue?vue&type=style&index=0&id=5335a9a1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5335a9a1"]])

export default __exports__